import { useQuery } from "react-query"
import { getTenantDiagnostics } from "./tenantDiagnosticsApi"

export const useTenantDiagnosticsQuery = (tenantId: number | undefined) => {
  return useQuery(['tenantDiagnostics', tenantId ?? 0], {
    queryFn: () => getTenantDiagnostics(tenantId!),
    enabled: !!tenantId,
    refetchOnWindowFocus: false
  })
}
